import { render } from "./corporates.vue?vue&type=template&id=685b40a9"
import script from "./corporates.vue?vue&type=script&lang=js"
export * from "./corporates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__